import {TenantCreate, TenantList, EmailServerSetting,GlobalUIConfig} from './views';

export default [
    {
        path: "/sadmin/create-tenant",
        name: "Create a new tenant",
        component: TenantCreate,
        meta: {
            authGuard: (user) => user.isSuperAdmin
        }
    },
    {
        path: "/sadmin/tenants",
        name: "List of tenants",
        component: TenantList,
        meta: {
            authGuard: (user) => user.isSuperAdmin
        }
    },
    {
        path: "/sadmin/email-settings",
        name: "Email Server Settings",
        component: EmailServerSetting,
        meta: {
            authGuard: (user) => user.isAdmin
        }
    },
    {
        path: "/sadmin/global-ui-config",
        name: "Global UI config",
        component: GlobalUIConfig,
        meta: {
            authGuard: (user) => user.isAdmin
        }
    }
];
